import { ChatHeader } from "../../Chat/ChatHeader";
import { useChannelMetadata } from "../hooks/useChannelMetadata";

interface ClipboardGuidesChatHeaderTitleProps {
  onBack: () => void;
}

export function ClipboardGuidesChatHeaderTitle(
  props: ClipboardGuidesChatHeaderTitleProps
): JSX.Element {
  const { onBack } = props;
  const metadata = useChannelMetadata();

  const workplaceName = metadata?.facilityName;

  return (
    <ChatHeader
      title={workplaceName ? `Community at ${workplaceName}` : "Community"}
      subtitle="Ask the regulars"
      onBack={onBack}
    />
  );
}
